import React from "react";
import { Link } from "react-router-dom";
import Bg from "../../images/shapes/shape_net_ico_hero_section_bg.svg";
import icon1 from "../../images/services/coin-bg.png";
import goldEndImg from "../../images/captain-tc/GoldEnd.png";
import CaptainTCCardsContent from "../CaptainTCCardsContent";
import CaptainTCBronzeCardsContent from "../CaptainTCBronzeCardsContent";
import CaptainTCSilverCardsContent from "../CaptainTCSilverCardsContent";
import CaptainTCGoldCardsContentNew from "../CaptainTCGoldCardsContentNew";
import CaptainTCCopperCardsContent from "../CaptainTCCopperCardsContent";

const Hero = () => {
  return (
    <section
      className="ico_hero_section section_decoration text-center"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        <img loading="lazy" src={icon1} alt="ICO Site Logo" />

        <div className="row justify-content-center pb-2">
          <div className="col-lg-10">
            <h1
              className="hero_title mb-2 nxt_generation"
              data-aos="fade-up"
              data-aos-duration="800"
              style={{ fontSize: "50px" }}
            >
              Welcome to TopCoin UK!
            </h1>
            <h2 className="mb-3">NEW GENERATION TOPCOIN REWARDS</h2>
            <h4 className="" data-aos="fade-up" data-aos-duration="800">
              "Get Free TopCoin Every Time You Shop"
            </h4>

            <p className="mb-0">
              TopCoin UK is the UK's smart rewards and loyalty system. When you
              shop at participating businesses, you receive free TopCoin as part
              of our customer rewards programme. Customers from anywhere can
              collect TopCoin, access their wallets, and view available reward
              balances through TopCoin UK's loyalty system — with no hidden fees
              or sign-up charges.
            </p>

            <div className="bonus-info mt-4">
              <h5 className="mb-2">Join Today and Unlock Your Rewards</h5>
              <p className="mb-3">
                When you join TopCoin UK, you will receive 5,000 Reward TopCoin
                as part of your starter package. These rewards become available
                once you reach a total of 20,000 TopCoin through normal
                participation in the TopCoin UK programme.
              </p>
              <p className="mb-3">
                TopCoin UK Ltd is an advertising, rewards, and discount company.
                TopCoin UK Ltd is the company name and is not a cryptocurrency
                or digital coin. We are not a gambling or investment business.
              </p>
              <ul
                className="btns_group unordered_list justify-content-center mt-4 p-0"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-delay="100"
              >
                <li>
                  <Link className="ico_creative_btn" to="/sign_up">
                    <span className="btn_wrapper px-5 py-3">
                      <span className="btn_label">
                        Join Now & Get Your TopCoin
                      </span>
                      <span className="btn_icon_right">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          fill="currentColor"
                        >
                          <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                        </svg>
                      </span>
                    </span>
                  </Link>
                </li>
              </ul>

              <p className="mb-2 mt-5" style={{ fontWeight: 600 }}>
                How Your Bonus TopCoin Works
              </p>
              <p className="mb-2">
                Bonus TopCoin is added to your main TopCoin balance as "Bonus
                TopCoin."
              </p>
              <p className="mb-2" style={{ fontWeight: 600 }}>
                This Bonus TopCoin is an additional reward given to support your
                progress.
              </p>

              <div
                className="captain-tc-card-section mt-5"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <h5
                  style={{
                    textAlign: "center",
                    color: "#CCCEEF",
                    fontSize: "28px",
                    fontWeight: "bold",
                    margin: "0 0 5px 0",
                  }}
                >
                  Captain TC Gold Rewards Card
                </h5>
                <CaptainTCCardsContent />
              </div>
              <div
                className="captain-tc-card-section mt-5"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <h5
                  style={{
                    textAlign: "center",
                    color: "#CCCEEF",
                    fontSize: "28px",
                    fontWeight: "bold",
                    margin: "0 0 5px 0",
                  }}
                >
                  Captain TC Copper Rewards Card
                </h5>
                <CaptainTCCopperCardsContent />
              </div>

              <div
                className="captain-tc-card-section mt-5"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <h5  style={{
                    textAlign: "center",
                    color: "#CCCEEF",
                    fontSize: "28px",
                    fontWeight: "bold",
                    margin: "0 0 5px 0",
                  }}>
                  Captain TC Silver Rewards Card
                </h5>
                <CaptainTCSilverCardsContent />
              </div>

              <div
                className="captain-tc-card-section mt-5"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <h5  style={{
                    textAlign: "center",
                    color: "#CCCEEF",
                    fontSize: "28px",
                    fontWeight: "bold",
                    margin: "0 0 5px 0",
                  }}>
                  Captain TC Bronze Rewards Card
                </h5>
                <CaptainTCBronzeCardsContent />
              </div>

              <div
                className="captain-tc-card-section mt-5"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <h5  style={{
                    textAlign: "center",
                    color: "#CCCEEF",
                    fontSize: "28px",
                    fontWeight: "bold",
                    margin: "0 0 5px 0",
                  }}>
                  Captain TC Gold Rewards Card
                </h5>
                <CaptainTCGoldCardsContentNew />
              </div>
              {/* 5th Promo Webcontent */}
      <div
        className="captain-tc-promo-webcontent-5"
        style={{ marginBottom: "30px" }}
      >
        <img
          src={goldEndImg}
          alt="Gold End"
          style={{
            maxWidth: "100%",
            height: "auto",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        />
        <h2
          style={{
            margin: "0 0 15px",
            fontSize: "1.5rem",
            letterSpacing: "1px",
            fontWeight: "bold",
            color: "#fff",
          }}
        >
          Collect 5000 Captain TC Gold Cards<br />
          Be rewarded up to £4000
        </h2>
        <div className="captain-tc-promo5-content">
          <p
            className="captain-tc-promo5-text"
            style={{ textAlign: "center", marginBottom: "0", color: "#ddd" }}
          >
            Collect Captain TC Gold Cards through qualifying product purchases from participating
            companies on the Topcoin UK platform and receive a £16 reward for every 20 qualifying
            Gold Cards collected; you can continue collecting throughout your Captain TC Rewards
            journey, with 20 cards = £16, 100 cards (5 sets) = £80, 500 cards (25 sets) = £400,<br/><br/>
            1,000 cards (50 sets) = £800, and 5,000 cards (250 sets) = £4,000, so the amount you
            receive depends on the number of qualifying Gold Cards you collect, up to £4,000 for
            5,000 qualifying Gold Cards, and this reward is available with Captain TC Copper, Silver, Bronze and Gold Rewards Cards.
          </p>
        </div>
      </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
